import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  accent?: boolean;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = '查看全部',
  accent = false,
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="flex items-center gap-3 min-w-0">
        <span className={`w-1 h-6 md:h-7 rounded-full ${accent ? 'bg-accent-500' : 'bg-primary-500'}`}></span>
        <div className="min-w-0">
          <h2 className="font-heading font-bold text-lg md:text-2xl text-foreground-950 truncate">{title}</h2>
          {subtitle && <p className="text-xs md:text-sm text-foreground-500 mt-0.5 truncate">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap shrink-0 cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}